import { ALARM_ENUM_VALUE_MAP } from "consts";
import { usePolicyDetail } from "data/ss-data-hooks";

export const usePropertyUpdateSecurity = () => {
  const { data, isLoading } = usePolicyDetail();
  const burglarKey = data?.userPropertyProfileData.burglarAlarm ?? "";
  const fireKey = data?.userPropertyProfileData.fireAlarm ?? "";
  const prevBurglar = ALARM_ENUM_VALUE_MAP[burglarKey];
  const prevFire = ALARM_ENUM_VALUE_MAP[fireKey];

  return {
    loading: isLoading,
    prevBurglar,
    prevFire,
  };
};
